"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playerReducers = exports.spectatingReducer = exports.cardShopReducer = void 0;
const models_1 = require("@creature-chess/models");
const toolkit_1 = require("@reduxjs/toolkit");
exports.cardShopReducer = (0, toolkit_1.createReducer)(models_1.initialCardShopState, (builder) => {
    builder
        .addCase(models_1.PlayerCommands.updateCardsCommand, (state, action) => {
        state.cards = action.payload;
    })
        .addCase(models_1.PlayerCommands.updateShopLockCommand, (state, action) => {
        state.locked = action.payload;
    });
});
exports.spectatingReducer = (0, toolkit_1.createReducer)(models_1.initialSpectatingState, (builder) => {
    builder.addCase(models_1.PlayerCommands.setSpectatingIdCommand, (state, action) => {
        state.id = action.payload;
    });
});
exports.playerReducers = {
    cardShop: exports.cardShopReducer,
    spectating: exports.spectatingReducer,
};
